'use client';

import { type TireEfficiencyFlagSpecificProps } from '@packages/shared/src/ui/TireEfficiencyFlag/TireEfficiencyFlag';
import type { EfficiencyFlagOverlay } from '@packages/modules/src/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog';
import { EfficiencyFlagOverlayDialog } from '@packages/modules/src/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog';
import { TireEfficiencyFlagLocalized } from '../EfficiencyFlagLocalized/TireEfficiencyFlagLocalized/TireEfficiencyFlagLocalized';

export type ProductCardV2TireEfficiencyFlagsProps = {
  flags: ReadonlyArray<TireEfficiencyFlagSpecificProps & { overlay?: EfficiencyFlagOverlay }>;
};

export const ProductCardV2TireEfficiencyFlags = ({
  flags,
}: ProductCardV2TireEfficiencyFlagsProps) => (
  <div className="flex flex-wrap gap-0.5">
    {flags.map(({ overlay, ...flagProps }, index) => (
      <EfficiencyFlagOverlayDialog key={overlay?.title ?? index} overlay={overlay}>
        {/* leading-none is necessary because the ...OverlayDialog sets the button to line-height:0, which cascades down to the flag itself, for some reason the flag text-size doesn't specify a line-height */}
        <TireEfficiencyFlagLocalized className="leading-none" {...flagProps} />
      </EfficiencyFlagOverlayDialog>
    ))}
  </div>
);
